import React from "react";
import ReactDOM from "react-dom";

// Criar ou localizar a área onde a modal vai ser renderizada no DOM
let modalRoot = document.getElementById("modal-root");

if (!modalRoot) {
  modalRoot = document.createElement("div");
  modalRoot.id = "modal-root";
  document.body.appendChild(modalRoot);
}

class NewModalManager {
  static modalContainer = null;

  // Abre a modal
  static openModal(content) {
    NewModalManager.closeModal(); // Fecha qualquer modal aberta antes de abrir uma nova
    NewModalManager.modalContainer = ReactDOM.createPortal(
      content,
      modalRoot
    );

    ReactDOM.render(NewModalManager.modalContainer, modalRoot);
  }

  // Fecha a modal
  static closeModal() {
    if (modalRoot) {
      ReactDOM.unmountComponentAtNode(modalRoot);
    }
  }
}

export default NewModalManager;
